import { TableCell, TableHead, TableRow } from '@mui/material';
import { withStyles } from 'tss-react/mui';
import PropTypes from 'prop-types';
import CrpCheckbox from '../atoms/CrpCheckbox';

const styles = {
  checkBoxCell: {
    width: 90,
  },
  headerTitle: {
    color: '#A2A2A2',
    borderStyle: 'hidden',
  },
};

const ContainerTableHead = ({
  onSelectAllClick,
  classes,
  selectAllChecked,
  columns,
  checkboxes,
  centerAlign,
}) => {
  return (
    <TableHead>
      <TableRow>
        {checkboxes && (
          <TableCell className={classes.headerTitle}>
            <CrpCheckbox onChange={onSelectAllClick} checked={selectAllChecked} />
          </TableCell>
        )}
        {columns.map((column) => {
          return (
            <TableCell
              align={centerAlign ? 'center' : 'inherit'}
              className={classes.headerTitle}
              key={column.id}
              colSpan={column.colSpan ? column.colSpan : 1}
              numeric={column.numeric}
            >
              {column.label}
            </TableCell>
          );
        })}
      </TableRow>
    </TableHead>
  );
};

ContainerTableHead.propTypes = {
  columns: PropTypes.array.isRequired,
  checkboxes: PropTypes.bool,
  onSelectAllClick: PropTypes.func,
  selectAllChecked: PropTypes.bool,
};

export default withStyles(ContainerTableHead, styles);
